// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"8626bb7a","71":"c59b186f","249":"3bd15a5d","791":"1be9c946","886":"bcb65047"}[chunkId] + ".js";
};